import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import AlertMain from "./AlertMain";
import StatusComp from "../../../components/StatusComp";

const AdminAlertTypes = () => {
  const location = useLocation();
  const { type, datas, data } = location?.state;
  const navigate = useNavigate();
  const createdAt = moment().format("DD-MM-YYYY,h:mm A");
  return (
    <div className="dashRightView">
      <StatusComp name={"Alert"} type={"Types"} hide={!type} />

      {type && (
        <div className="d-flex p-1">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Company Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${datas?.companyName ?? "Ninos"} - ${
                  data?.companyId ?? "N001"
                }`}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${datas?.siteName ?? "Robotics"} - ${
                  data?.siteCode ?? "R001"
                }`}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Location
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={datas?.siteLocation ?? "Chennai,vadapalani"}
              />
            </div>
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={datas?.siteAdminName ?? "Shakthivel"}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Admin Created On
              </p>
              <input className="input-box w-100" readOnly value={createdAt} />
            </div>
          </div>
        </div>
      )}

      {type && (
        <div className="col-md-12 p-3 d-flex ac-js gap-5">
          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/site-report", {
                  state: {
                    data: datas,
                    type: "site-view",
                  },
                })
              }
            >
              View report
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-notifications", {
                  state: {
                    data: datas,
                    type: "site-view",
                  },
                })
              }
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-slot-main", {
                  state: { type: "site-view", data: datas, superAdmin: true },
                })
              }
            >
              View slot days
            </button>
          </div>
          <div className="p-2 mb-2">
            <button className="submit-btn">Alert Types</button>
          </div>
          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-cameras", {
                  state: {
                    type: "site-view",
                    data: datas,
                  },
                })
              }
            >
              Cameras
            </button>
          </div>
        </div>
      )}
      <AlertMain ind={"ind"} />
    </div>
  );
};

export default AdminAlertTypes;
